import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData, generalItemUpload} from '../middleware/apiMiddleware';
import s from './VIPWriting.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import addCirclePng from'../asset/add-circle.png';
import {Image} from 'react-bootstrap';
import musicPlayer from'../asset/music-player.png';

const MyTextarea = ({enabledJsonCheck = false, title, setter, getter}) => {
	const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
	
	return (<>
		<div style={{display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontWeight:"bold", fontSize:"32px"}}>{title}</div>			
			{(enabledJsonCheck && !isJson(getter)) && (<div className={s.fadeInOut} style={{fontWeight:"bold", fontSize:"26px", color:"red"}}>invalid JSON!</div>)}
		</div>
	
		<textarea style={{border:"1px solid #22222222", width:"100%",
			overflow: 'auto',
			whiteSpace: 'pre-wrap',
			wordWrap: 'break-word'}} value={getter} className={s.textAreaAuto} 
			rows={10} wrap='off' onChange={(e) => {
			setter(e.target.value);
		}}/>
	</>)
}

export default function VIPWriting(prop) {	
	const navigate = useNavigate();
	let itemId = prop.itemId;
	
	const [writingTopic, setWritingTopic] = useState("");
	const [writingResource, setWritingResource] = useState("");
	const [writingLevel, setWritingLevel] = useState("");
	const [originalEssay, setOriginalEssay] = useState("");
	const [enhancedEssay, setEnhancedEssay] = useState("");
	const [comparison, setComparison] = useState("");
	const [comment, setComment] = useState("");
	
	const [enhancedEssayLoading, setEnhancedEssayLoading] = useState(false);
	const [comparisonLoading, setComparisonLoading] = useState(false);
	const [commentLoading, setCommentLoading] = useState(false);	
	
	const [goodEssay, setGoodEssay] = useState("");
	const [essence, setEssence] = useState("");
	const [outline, setOutline] = useState("");
	
	const [instruction, setInstruction] = useState("");
	const [notes, setNotes] = useState("");
	
	const [newOutline, setNewOutline] = useState("");
	const [lv3, setLv3] = useState("");
	const [lv4, setLv4] = useState("");
	const [lv5, setLv5] = useState("");
	
	const [instructionPic, setInstructionPic] = useState(null);
	
	// update functions (already exist, kept intact)
	const updateWritingTopic = async () => {
		let obj = { itemId, writingTopic }
		await postData("vipWritingApi/updateWritingTopic", obj, navigate); 
	}

	const updateWritingResource = async () => {
		let obj = { itemId, writingResource }
		await postData("vipWritingApi/updateWritingResource", obj, navigate); 
	}

	const updateOriginalEssay = async () => {
		let obj = { itemId, 'article' : originalEssay }
		await postData("vipWritingApi/updateOriginalEssay", obj, navigate); 
	}
	
	const updateEnhancedEssay = async () => {
		let obj = { itemId, 'article' : enhancedEssay }
		await postData("vipWritingApi/updateEnhancedEssay", obj, navigate); 
	}
		
	const updateComparison = async (itemId) => {
		let obj = { itemId, comparison }
		await postData("vipWritingApi/updateComparison", obj, navigate); 
	}
	
	const updateComment = async () => {
		let obj = { itemId, 'article' : comment }
		await postData("vipWritingApi/updateComment", obj, navigate); 
	}
	
	const updateGoodEssay = async () => {
		let obj = {itemId,'article' : goodEssay}
		await postData("vipWritingApi/updateGoodEssay", obj, navigate); 
	}
	
	const updateEssence = async () => {
		let obj = { itemId, 'article' : essence }
		await postData("vipWritingApi/updateEssence", obj, navigate); 
	}
	
	const updateOutline = async () => {
		let obj = { itemId, 'article' : outline }
		await postData("vipWritingApi/updateOutline", obj, navigate); 
	}
	
	const updateInstruction = async () => {
		let obj = {itemId, 'article' : instruction }
		await postData("vipWritingApi/updateInstruction", obj, navigate); 
	}
	
	const processCompleteNewOutline = async () => {
		await getData("vipWritingApi/processCompleteNewOutline?itemId=" + itemId, navigate);
		fetchData();
	}
	
	const updateNotes = async () => {
		let obj = { itemId, 'article' : notes }
		await postData("vipWritingApi/updateNotes", obj, navigate); 
	}	
	
	const updateWritingInstructionImg = async (itemId, path) => {
		let obj = {itemId, path}
		let res = await postData("vipWritingApi/updateWritingInstructionImg", obj, navigate); 		
		setInstructionPic(res.data);
	}
	
	// generate AI functions (kept intact)
	const genEnhancedEssay = async () => {
		setEnhancedEssayLoading(true);
		let obj = { itemId, 'article' : originalEssay }
		let res = await postData("vipWritingApi/genEnhancedEssay", obj, navigate); 
		setEnhancedEssay(res.data);
		setEnhancedEssayLoading(false);
	}
	
	const genComparisonJson = async (itemId, original, enhanced) => {
		let obj = { itemId, original, enhanced }
		let res = await postData("vipWritingApi/genComparisonJson", obj, navigate); 
		setComparison(res.data);
	}

	const genComment = async () => {
		setEnhancedEssayLoading(true);
		let obj = { itemId, originalEssay, enhancedEssay }
		let res = await postData("vipWritingApi/genComment", obj, navigate); 
		setComment(res.data);
		setCommentLoading(false);
	}
	
	const genGoodEssay = async () => {
		let obj = {
			itemId,
		}
		let res = await postData("vipWritingApi/genGoodEssay", obj, navigate); 
		setGoodEssay(res.data)
	}
	
	const aiGetGoodEssay = async () => {
		let obj = {
			itemId,
		}
		let res = await postData("vipWritingApi/aiGetGoodEssay", obj, navigate); 
		setGoodEssay(res.data)
	}
	
	const translateGoodEssay = async () => {
		let obj = {
			itemId,
			'article' : goodEssay
		}
		let res = await postData("vipWritingApi/translateGoodEssay", obj, navigate); 
		setGoodEssay(res.data)
	}
	
	const genEssence = async (mode) => {
		let obj = {itemId,mode}
		let res = await postData("vipWritingApi/genEssence", obj, navigate); 
		setEssence(res.data)
	}
	
	const translateEssence = async () => {
		let obj = { itemId, 'article' : essence }
		let res = await postData("vipWritingApi/translateEssence", obj, navigate); 
		setEssence(res.data)
	}
	
	const genOutline = async () => {
		let obj = {
			itemId,
		}
		let res = await postData("vipWritingApi/genOutline", obj, navigate); 
		setOutline(res.data)
	}
	
	const translateOutline = async () => {
		let obj = {
			itemId,
			'article' : outline
		}
		let res = await postData("vipWritingApi/translateOutline", obj, navigate); 
		setOutline(res.data)
	}
	
	const convertSrt = async () => {
		let obj = {
			itemId,
		}
		await postData("item/processSpeakingHkSrt", obj, navigate); 
		fetchData();
	}
	
	const SoundPlayer = ({soundFile}) => {
    var savingCurrencySound = soundFile;
    var playCurrencySound = () => {     
        var audio = new Audio(savingCurrencySound);
        audio.play();
    }
    return (
			<Image className={s.music_player} fluid onClick={ () => playCurrencySound() }
				src={musicPlayer} rounded />
    );
	}
	
	const removeInstructionImage = async () => {
		let obj = { itemId }
		await postData("vipWritingApi/removeInstructionImage", obj, navigate); 
		setInstructionPic(null);
	}
	
	const fetchData = async () => {
		getData('vipWritingApi/vipData?itemId=' + itemId, navigate)
		.then(res => {
				if(res.data) {
					setOriginalEssay(res.data['original_essay'] ?? "");
					setEnhancedEssay(res.data['enhanced_essay'] ?? "");
					setComment(res.data['comment'] ?? "");
					setComparison(res.data['comparison'] ?? "");					
					setGoodEssay(res.data['good_essay'] ?? "");
					setEssence(res.data['essence'] ?? "");					
					setOutline(res.data['outline'] ?? "");
					setNotes(res.data['notes'] ?? "");
					setInstruction(res.data['instruction'] ?? "");
					setInstructionPic(res.data['instructionPic']);
					setNewOutline(prettyJson(res.data['new_outline']));
					setLv3(prettyJson(res.data['lv_3']));
					setLv4(prettyJson(res.data['lv_4']));
					setLv5(prettyJson(res.data['lv_5']));
				}
			}
		);

		getData('vipWritingApi/writingResource?itemId=' + itemId, navigate)
			.then(res => {
				if(res.data) {
					setWritingTopic(res.data['writing_topic'] ?? ""); // load writingTopic data
					setWritingResource(res.data['writing_resource'] ?? ""); // load writingResource data
					setWritingLevel(res.data['writing_level'] ?? "");
				}
			});
	}
	
	const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const prettyJson = (str) => {
	if (!str) return "";
    try {
      return JSON.stringify(JSON.parse(str), null, 2);
    } catch (e) {
      return str;
    }
  };
	
	useEffect(() => {
		fetchData();
	}, []);
	
	return (<div style={{textAlign:"left", marginLeft:"20px"}}>
		<div>JSON formatter</div>
		<a href="http://json.parser.online.fr/" target="_blank">http://json.parser.online.fr/</a>

		<div style={{background:"#c8c9f9", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			{/* 1. New: Writing Topic (single-line input) */}
			<div style={{marginBottom: "20px"}}>
				<div style={{fontWeight: "bold", fontSize: "32px", marginBottom: "10px"}}>Writing Level</div>
				<select
					value={writingLevel}
					onChange={async (e) => {
						setWritingLevel(e.target.value);
						let obj = { itemId, writingLevel: e.target.value };
						await postData("vipWritingApi/updateWritingLevel", obj, navigate);
					}}
					style={{
						border: "1px solid #22222222",
						width: "100%",
						padding: "8px 12px",
						fontSize: "16px",
						borderRadius: "4px",
					}}
				>

					<option value="">Select Writing Level</option>
					<option value="Pre-DSE Very Simple Version">Pre-DSE Very Simple Version</option>
					<option value="DSE Simple version">DSE Simple version</option>
					<option value="DSE Well-Developed Version (Lv5**)">DSE Well-Developed Version (Lv5**)</option>
					<option value="Professional Version (Beyond 5**) for Appreciation">Professional Version (Beyond 5**) for Appreciation</option>
					<option value="S1-3 Simple version">(初中)S1-3 Simple version</option>
					<option value="Pre-DSE Elite version">(初中)Pre-DSE Elite version</option>
				</select>
			</div>

			<div style={{marginBottom: "20px"}}>
				<div style={{fontWeight:"bold", fontSize:"32px", marginBottom:"10px"}}>Writing Topic</div>
				<input 
					type="text" 
					value={writingTopic}
					onChange={(e) => setWritingTopic(e.target.value)}
					style={{
						border:"1px solid #22222222", 
						width:"100%", 
						padding:"8px 12px",
						fontSize:"16px",
						borderRadius:"4px"
					}}
					placeholder="Enter writing topic (short string)..."
				/>
				<div style={{marginTop:"10px"}}>
					<GreenButton 
						isEnabled={writingTopic.trim() !== ""} // Enable only when input is not empty
						clickedAction={updateWritingTopic} 
						bText={"Update Writing Topic"} 
					/>
				</div>
			</div>

			{/* 2. Writing Resource (existing textarea + added update button) */}
			<MyTextarea title={"Writing Resource"} setter={setWritingResource} getter={writingResource} />
			<div style={{display:"flex", gap:"10px", marginBottom:"20px"}}>
				<GreenButton 
					isEnabled={writingResource.trim() !== ""} // Enable only when input is not empty
					clickedAction={updateWritingResource} 
					bText={"Update Writing Resource"} 
				/>
			</div>

			<MyTextarea title={"Original Essay"} setter={setOriginalEssay} getter={originalEssay} />
			<div style={{display:"flex", gap:"10px"}}>
				<GreenButton clickedAction={updateOriginalEssay} bText={"Update"} />
			</div>
			
			<MyTextarea title={"Enhancement Essay"} setter={setEnhancedEssay} getter={enhancedEssay} />
			<div style={{display:"flex", gap:"10px"}}>
				<RedButton isEnabled={(originalEssay != "" && !enhancedEssayLoading)} clickedAction={genEnhancedEssay} bText={"AI"}/>
				<GreenButton isEnabled={!enhancedEssayLoading} clickedAction={updateEnhancedEssay} bText={"Update"} />
			</div>
		</div>

		<div style={{background:"#eed1ec", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"Good Essay"} setter={setGoodEssay} getter={goodEssay} />
			<div style={{display:"flex", gap:"10px"}}>
				<RedButton clickedAction={genGoodEssay} bText={"AI"}/>
				<BlueButton isEnabled={isJson(essence)} clickedAction={translateGoodEssay} bText={"gen translate & audio"}/>
				<GreenButton clickedAction={updateGoodEssay} bText={"Update"} />
			</div>
		</div>
		
		<div style={{background:"#d1e0ed", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>		
			<MyTextarea enabledJsonCheck={true} title={"Essence"} setter={setEssence} getter={essence} />	
			<div style={{display:"flex", gap:"10px"}}>
				<RedButton clickedAction={()=>genEssence('completed')} bText={"AI(Completed)"} />
				<RedButton clickedAction={()=>genEssence('light')} bText={"AI(Light)"} />
				<BlueButton isEnabled={isJson(essence)} clickedAction={translateEssence} bText={"gen translate & audio"}/>
				<GreenButton isEnabled={isJson(essence)} clickedAction={updateEssence} bText={"Update"} />
			</div>
		</div>
		
		<div style={{background:"#c3ecc7", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"Outline"} setter={setOutline} getter={outline} />	
			<div style={{display:"flex", gap:"10px"}}>
				<RedButton clickedAction={genOutline} bText={"AI"} />
				<BlueButton isEnabled={isJson(outline)} clickedAction={translateOutline} bText={"gen translate & audio"}/>
				<GreenButton isEnabled={isJson(outline)} clickedAction={updateOutline} bText={"Update"} />
			</div>
		</div>
		
		<div style={{background:"#eebc99", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea title={"Instruction"} setter={setInstruction} getter={instruction} />	
			<div style={{display:"flex", gap:"10px"}}>
				<GreenButton clickedAction={updateInstruction} bText={"Update"} />
			</div>
		</div>
		<div style={{background:"#eebc99", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<GreenButton 
				isEnabled={instruction.trim() !== "" && outline.trim() !== ""}
				clickedAction={processCompleteNewOutline} 
				bText={"Process New Outline + 3 level outline"} 
			/>
		</div>
		
		<div style={{background:"#f0dfa8", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"New Outline"} setter={setNewOutline} getter={newOutline} />
		</div>
		
		<div style={{background:"#f0dfa8", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"Level 3 Outline"} setter={setLv3} getter={lv3} />
		</div>
		
		<div style={{background:"#f0dfa8", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"Level 4 Outline"} setter={setLv4} getter={lv4} />
		</div>
		
		<div style={{background:"#f0dfa8", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea enabledJsonCheck={true} title={"Level 5 Outline"} setter={setLv5} getter={lv5} />
		</div>
		
		<div style={{background:"#eebc99", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<label htmlFor={"instruction-img-upload"}  className={s.custom_file_upload} style={{margin:"5px"}}>
				<input id={"instruction-img-upload"} type="file" style={{display:"none"}} onChange={
					async (e) => {
						let path = await generalItemUpload(itemId, e.target.files[0], navigate);
						if (path) {
							updateWritingInstructionImg(itemId, path);
						}
					}} />
				Upload Image
			</label>	
			{
				(instructionPic) && (<div style={{display:"flex", flexDirection:"column", gap:"10px"}}>
					<img style={{width:"200px", height:"200px"}} src={instructionPic}	/>
					<div><GreenButton isEnabled={true} clickedAction={removeInstructionImage} bText={"Remove Image"} />
					</div>
				</div>)
			}
		</div>
		
		<div style={{background:"#ebc87c", padding:"15px", borderRadius:"5px", margin:"10px 0"}}>
			<MyTextarea title={"Notes"} setter={setNotes} getter={notes} />	
			<div style={{display:"flex", gap:"10px"}}>
				<GreenButton clickedAction={updateNotes} bText={"Update"} />
			</div>
		</div>
	</div>);
}